import React, { useRef } from 'react';
import { Button, Form } from 'react-bootstrap';
import { BsUpload } from 'react-icons/bs';
import { IoMdClose } from 'react-icons/io';
import { IoAddOutline, IoClose, IoCloudUploadOutline, IoDocumentAttachOutline, IoFileTrayStackedOutline } from 'react-icons/io5';

const NoteForm = ({ data, setData, inputError, setInputError }) => {

  const MAX_FILE_SIZE_MB = 1;
  const attachmentPickerRef = useRef(null);

  function handleChange(e) {
    let { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  return (
    <div className='row'>
      <div className='col-xl-12'>
        <Form.Group className="my-3" controlId="title">
          <Form.Label>Title *</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter the title"
            onChange={handleChange}
            className={inputError && inputError.title ? 'border-danger' : ''}
            value={data && data.title}
            isInvalid={inputError && inputError.title}
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.title}</Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='col-xl-12'>
        <Form.Group className="mb-3" controlId="note">
          <Form.Label>Note *</Form.Label>
          <Form.Control
            type="text"
            as="textarea"
            rows={5}
            placeholder="Enter note here..."
            onChange={handleChange}
            className={inputError && inputError.note ? 'border-danger' : ''}
            value={data && data.note}
            isInvalid={inputError && inputError.note}
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.note}</Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='col-xl-12'>
        <Form.Group className="mb-3" controlId="attachment">
          <Form.Label>Attachment</Form.Label>
          {
            data && data.attachments?.map((item, index) => {
              const fileSizeMB = item && item.size / (1024 * 1024);

              return (
                <div key={index} className='d-flex align-item-center justify-content-between border rounded p-3 mb-3'>
                  <div className='w-70 d-flex align-items-center'>
                    <IoDocumentAttachOutline size={18} color='var(--bs-secondary)' />
                    <div className='ms-3'>
                      {item && item.name}
                    </div>
                  </div>
                  <div className='w-15 text-placeholder'>
                    {fileSizeMB && fileSizeMB.toFixed(2)} MB
                  </div>
                  <div className='w-15'>
                    <div className='cursor-pointer' onClick={() => {
                      const tempArray = data && data.attachments.filter(a => a !== item);
                      setData({ ...data, attachments: tempArray });
                    }}>
                      <IoClose size={18} color='var(--bs-danger)' />
                    </div>
                  </div>
                </div>
              )
            })
          }
          <Form.Control
            hidden
            ref={attachmentPickerRef}
            type='file'
            onChange={(event) => {
              const fileSizeMB = event.target.files[0] && event.target.files[0].size / (1024 * 1024);

              if (fileSizeMB > 1) {
                setInputError({ ...inputError, attachments: `File size exceeds the limit of ${MAX_FILE_SIZE_MB} MB.` });
              } else {
                setInputError({ ...inputError, attachments: "" });
                const tempArray = data?.attachments ? [...data.attachments] : [];
                tempArray.push(event.target.files[0]);
                setData({ ...data, attachments: tempArray });
              }
            }}
          />
          <Button
            variant='outline-light'
            className={inputError && inputError.attachments ? 'border border-danger w-100 min-h-80px py-4' : 'border w-100 min-h-80px py-4'}
            onClick={() => attachmentPickerRef.current.click()}
          >
            <div className='w-100 text-center text-dark d-flex flex-column align-items-center justify-content-center'>
              <div className='activity-icon bg-info'>
                <IoFileTrayStackedOutline size={20} color='white' />
              </div>
              <p className='mb-0 mt-3 fw-light text-placeholder small'>Click to choose attachment.</p>
              <div className='text-info d-flex align-items-center border rounded px-3 py-1 mt-2'>
                <BsUpload />
                <small className='ms-2'>Upload</small>
              </div>
            </div>
          </Button>
          {
            inputError && inputError.attachments ?
              <p className='text-end mt-2 small text-danger'>{inputError && inputError.attachments}</p>
              :
              null
          }
        </Form.Group>
      </div>
    </div >
  )
}

export default NoteForm;
